import { useNavigate } from 'react-router-dom';

import { CardType } from '@/types';
import { Button, Icon, Typography } from '@/ui';

import HomeStatusBanner from '../../HomeStatusBanner';

import type { HomeCardPropsWithoutCallbacks } from '@/types';
import type { FC } from 'react';

type ChemistryCallCardProps = {
  card: HomeCardPropsWithoutCallbacks;
};

const ChemistryCallCard: FC<ChemistryCallCardProps> = ({ card }) => {
  const navigate = useNavigate();
  const { coach } = card;
  if (card.type !== CardType.MEET_COACH || !coach?.id) return null;

  const coachName =
    ('fullName' in coach && coach.fullName) ||
    coach.firstName ||
    'your potential coach';

  return (
    <HomeStatusBanner
      action={
        <Button
          className="w-full sm:w-auto"
          color="primary"
          variant="contained"
          onClick={() => navigate(`/m/book-chemistry-call/${coach.id}`)}
        >
          Schedule chemistry call
        </Button>
      }
      description={
        <Typography className="text-cement-700" variant="body1">
          Schedule a chemistry call with your potential coach,{' '}
          <span className="font-bold">{coachName}</span>
        </Typography>
      }
      icon={<Icon className="shrink-0 text-cement-500">calendar_today</Icon>}
      title={
        <Typography className="font-bold" variant="body1">
          You&apos;ve been matched!
        </Typography>
      }
    />
  );
};

export default ChemistryCallCard;
